import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AzureTranslatorService {
  private endpointAzureTranslator = environment.azureTranslatorEndpoint;
  private subscriptionKey = environment.azureTranslatorSubscriptionKey;
  private region = environment.azureTranslatorRegion;

  constructor(private http: HttpClient) {}

  translate(text: string, to: string): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this.subscriptionKey,
      'Ocp-Apim-Subscription-Region': this.region,
      'Content-Type': 'application/json',
    });
    const body = [{ Text: text }];
    const url = `${this.endpointAzureTranslator}&to=${to}`;
    return this.http.post(url, body, { headers });
  }
}
